export default __webpack_public_path__ + "img/947bac3a039e8b16775684d21ed3e843.jpg";